module.exports = __webpack_public_path__ + "img/The_Island_Topographic.1da76f96.jpg";